<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <div class="text-h6 font-weight-medium">- {{ configTypeTitle }}</div>
      <div class="d-flex justify-end" style="gap: 8px">
        <v-btn outlined @click="onEnableConfig" v-if="disabled">Thiết lập</v-btn>
        <v-btn outlined @click="onDisableConfig" :loading="loading" v-if="!disabled">Huỷ</v-btn>
        <v-btn color="primary" @click="onSave" :loading="loading" v-if="!disabled">Lưu</v-btn>
      </div>
    </div>
    <v-text-field
      placeholder="VD: 24.5"
      v-model="value"
      color="primary"
      outlined
      hide-details
      dense
      :disabled="disabled"
    />
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import {get} from 'lodash'
export default {
  props: {type: String, grade: String, department: String},
  data: () => ({value: '', disabled: true, loading: false}),
  computed: {
    ...mapGetters({cutoffMarks: 'enrollCutoffMark/items'}),
    configTypeTitle() {
      return this.type === 'enroll' ? 'Trúng tuyển' : 'Dự khuyết'
    },
  },
  methods: {
    ...mapActions({upgrade: 'enrollCutoffMark/upgrade'}),
    onEnableConfig() {
      this.disabled = false
    },
    onDisableConfig() {
      this.disabled = true
    },
    validate() {
      const v = this.value
      if (typeof v === 'string' && v.length) return true
      return false
    },
    async onSave() {
      const isValid = this.validate()
      if (!isValid) return this.$alert.error(`Vui lòng nhập giá trị cho "${this.configTypeTitle}"`)

      try {
        this.loading = true
        await this.upgrade({
          type: this.type,
          grade: this.grade,
          department: this.department,
          value: this.value,
        })
        this.onDisableConfig()
        this.$alert.success(
          `Thiết lập "Điểm chuẩn" cho ${this.configTypeTitle} đối với ${this.grade}, ${this.department} thành công!`,
        )
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    cutoffMarks: {
      handler(v) {
        if (Array.isArray(v) && v.length) {
          const found = v.find(i => i.type === this.type && i.department === this.department && i.grade === this.grade)
          this.value = get(found, 'value', '')
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

